import React from 'react';
import PropTypes from 'prop-types';
import clsx from "clsx";

export const Feature = (props) => {
  const {isCompact} = props;

  return (
    <li className="flex">
      {
        !isCompact &&
        <svg className="flex-shrink-0 w-6 h-6 text-primary" xmlns="http://www.w3.org/2000/svg" fill="none"
             viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"/>
        </svg>
      }

      <span className={clsx("text-gray-500", {[!isCompact]: 'ml-3'})}>{props.title}</span>
    </li>
  );
};

Feature.propTypes = {
  title: PropTypes.string.isRequired,
  isCompact: PropTypes.bool
}

Feature.defaultProps = {
  isCompact: false
}

export default Feature;